import { type FC } from 'react';
import { AdUnit } from './AdUnit';
import styles from '../styles/ads.scss';

type Props = {
    adId: string;
    elementId: string;
    width?: number;
    height?: number;
    lazyLoad?: boolean;
};

export const BillboardBannerAd: FC<Props> = ({
    adId,
    elementId,
    width = 320,
    height = 82,
    lazyLoad = false,
}) => {
    return (
        <div className={styles.billboardBanner} data-tn="billboard-banner-ad">
            <AdUnit
                adId={adId}
                elementId={elementId}
                width={width}
                height={height}
                lazyLoad={lazyLoad}
            />
        </div>
    );
};
